export default __webpack_public_path__ + "static/media/Frame 2.21920314.png";